import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalexpercommentbacktbn from './Modalexpercommentbacktbn';
import { URL,api } from '../../api';
import Modalexpercheck from './Modalexpercheck';
import Modalexpercommentbacktbn2sub2 from './Modalexpercommentbacktbn2sub2';




export default class Commentexlistpsfsentback extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   expert_id:'',
   commentbn:[],
   url:'https://mua.kpru.ac.th/FrontEnd_Kprupsf/',
   
}


//this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.list = this.list.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
;  this.props.selectex();
}


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_send:this.props.id_send,
                       expert_id:this.props.expert_id,
         })
      setTimeout(() => {
       
        api.get('registercon/Selectarticpsfbnback2/'+this.props.id_emp+'/'+this.props.id_articlepsf, )
        .then(res => {
          console.log(res);
       
          this.setState({ commentbn: res.data})
        }) 

      }, 0);

  }

  list() {
 
      setTimeout(() => {
        api.get('registercon/Selectarticpsfbnback2/'+this.props.id_emp+'/'+this.props.id_articlepsf, )
        .then(res => {
          console.log(res);
          this.setState({ commentbn: res.data})
        }) 

      }, 0);

  }



    render() {
        

        return (
            <>




           <MDBTable small>
      <MDBTableHead color="blue-grey lighten-3" textWhite>
        <tr>
          <th>ลำดับ</th>
          <th>ไฟล์ข้อเสนอแนะ</th>
          <th>วันที่ส่งไป/กลับ</th>
        
          
          {/* <th>สถานะ ผ่าน/ปรับแก้ไข</th> */}
          <th>ข้อเสนอแนะ</th>
          <th>สถานะ</th>
          <th>จัดการ</th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
                      {this.state.commentbn.map((commentbn,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{commentbn.send_uploadcommentepdfbn2 !== null ? <>
                            <a href={`${this.state.url+commentbn.send_uploadcommentepdfbn2}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-word" /> ไฟล์ข้อเสนอแนะ .pdf</p> </a>
                           </>:<>
                           {commentbn.send_uploadewordbn2 !== null ? <>
                               <a href={`${this.state.url+commentbn.send_uploadewordbn2}`}  target="_blank"><p className="blue-text"><MDBIcon far icon="file-word" /> ไฟล์ PDF02.word</p> </a>
                               <a href={`${this.state.url+commentbn.send_uploadepdfbn2}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-word" /> ไฟล์ PDF02.pdf</p> </a>
                               {commentbn.send_uploadcommentelistpdfbn2 !== null ?<>
                               <a href={`${this.state.url+commentbn.send_uploadcommentelistpdfbn2}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-word" /> ไฟล์ เปรียบเทียบแก้ไข.pdf</p> </a>
                               </>:<> </>}
                           </>:<>
                             <MDBIcon far icon="hourglass" />
                           </>}
                           
                           
                           </>}</td>

                        <td>{ commentbn.statusbn2 === '3' || commentbn.statusbn2 === '4'?<>{commentbn.date_senbackbn2}</>:<>{commentbn.dateaddbn2}</> }</td>

                        {/* <td>{commentbn.filewordcomment_bn !== null ? <>{commentbn.filewordcomment_bn}</>:<><MDBIcon far icon="hourglass" /></>}</td> */}
                        
                        {/* <td>{commentbn.send_uploadcommentepdfex !== null  ? <>
                            <a href={`${this.state.url+commentbn.send_uploadcommentepdfex}`} target="_blank"><p className="green-text"><MDBIcon far icon="file-word" /> ไฟล์ข้อเสนอแนะ .pdf</p> </a>
                            
                           </>:<>
                           {commentbn.statusex ==='2'?<>-</>:<> <MDBIcon far icon="hourglass" /></>}
                          
                           </>}</td> */}

                        {/* <td>{ commentbn.date_addcr !== null ?<>{commentbn.date_addcr}</>:<><MDBIcon far icon="hourglass" /></>}</td> */}

                        {/* <td >{commentbn.scoreall==='2'?<> <span className="teal-text font-weight-bold">ผ่าน</span></>:<>
                               {commentbn.scoreall==='3'?<><span className="teal-text font-weight-bold">ผ่าน มีแก้ไข (ไม่ขอดูไฟล์)</span></>:<>
                                {commentbn.scoreall==='4'?<><span className="text-warning font-weight-bold">ผ่าน มีแก้ไข (ขอดูไฟล์อีกครั้ง)</span></>:<>
                                 {commentbn.scoreall==='0'?<><span className="text-danger font-weight-bold">ไม่ผ่าน</span></>:<>
                                 <MDBIcon far icon="hourglass" /> รอพิจารณา
                                 </>}
                                 
                                </>}
                              
                               </>}
                            </>}
                        </td> */}

                       <td>{ commentbn.statusbn2 === '3' || commentbn.statusbn2 === '4' ?<>{commentbn.bn_commentbn2}</>:<>-</> }</td> 
                       <td>{commentbn.statusbn2 === '3' || commentbn.statusbn2 === '4' ?<>ส่งกลับปรับแก้</>:<>
                            แก้ไขกลับมา

                       </>}</td>
                        <td>{ commentbn.statusbn2 === '3' || commentbn.statusbn2 === '4' ?<>-</>:<>
                        {commentbn.statusbn2 === '2' ?<>ส่งกรรมการแล้ว</>:<>

                        <Modalexpercommentbacktbn2sub2 idarticlebn2={commentbn.idarticlebn2} id_empbn2={commentbn.id_empbn2} id_articlepsf2={commentbn.id_articlepsf2} nameuserbn2={commentbn.nameuserbn2} send_uploadewordbn2={commentbn.send_uploadewordbn2} send_uploadepdfbn2={commentbn.send_uploadepdfbn2} send_uploadcommentelistpdfbn2={commentbn.send_uploadcommentelistpdfbn2}  list={this.list} /></>}
                        </>}
                        </td>

                        </tr>
                      )}
       
      </MDBTableBody>
    </MDBTable>
           
          </>
          
        )
    }
}


